import React, { useEffect, useState } from 'react';
import './index.scss';
import star_maker from './img/web_logo.png'
import { Privay, Service, tabList } from './static'
import { getParam } from '../../utils'
const Doc = (props) => {
  const [current, setCurrent] = useState(0)
  const setCur = (index) => {
    setCurrent(index)
  }
  useEffect(() => {
    const type = getParam('type')
    console.log('getParam', type)
    if (type) {
      setCurrent(parseInt(type))
    }
  }, [])
  return (
    <div className="doc-page">
      <div className='doc-title h-24 px-44'>
        <img className='pt-4' src={star_maker} alt="" />
      </div>
      <div className='doc-tab px-44 border-b-2'>
        {tabList && tabList.map((item, index) => (
          <div className={`doc-tab-item h-10 cursor-pointer ${current === index ? 'active' : ''}`} onClick={() => setCur(index)} key={item.text}>
            {item.text}
            {index === 0 && (
              <div className='doc-tab-line'></div>
            )}
          </div>
        ))}
      </div>
      <div className='doc-content px-44 pt-5 pb-8'>
        {current === 0 ? <Privay /> : <Service />}
      </div>
    </div>
  );
}

export default Doc;
